import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const ProductsActionTypes = {
  FETCH_DESIGN_TO_ORDER_ENTRIES: createSubtypes('products|fetchDesignToOrderEntries'),
};
